import React, { useState, useEffect } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MuiToggleButton from "@mui/material/ToggleButton";
import { styled } from "@mui/material/styles";
import Accordion from '@mui/material/Accordion';
import SaveBackgroundMusicFilter from '../dialogs/SaveBackgroundMusicFilter';
import TR from './../../Trans';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import bgFiltersStore from '../../stores/bgFilters';
import sessionStore from '../../stores/session';
import { render } from '@testing-library/react';

const ToggleButton = styled(MuiToggleButton)({
  "&.Mui-selected, &.Mui-selected:hover": {
    background: "var(--box-text-color) !important",
    borderColor: "var(--text-color) !important",
    color: "var(--back-color) !important",
  }

});

function SearchFilters(props) {

  const languages = () => {
    if (props.languages && props.filterLanguages) {
      return props.languages.map((lang) => {

        let isSelected = false;
        let filterLanguage = props.filterLanguages[lang.id];
        if (filterLanguage) {
          isSelected = filterLanguage;
        }
        return <ToggleButton
          className="muvika-search-filter-toggle-button"
          key={lang.id}
          value="check"
          selected={isSelected}
          size="small"
          onMouseDown={() => props.onLanguageChange(lang.id, isSelected)}
        >
          {lang.name}
        </ToggleButton>;
      }
      );
    };
  };

  const genres = () => {
    if (props.genres && props.filterGenres) {
      return props.genres.map((genre) => {

        let isSelected = false;
        let filterGenre = props.filterGenres[genre.id];
        if (filterGenre) {
          isSelected = filterGenre;
        }
        return <ToggleButton
          className="muvika-search-filter-toggle-button"
          key={genre.id}
          value="check"
          selected={isSelected}
          size="small"
          onMouseDown={() => props.onGenreChange(genre.id, isSelected)}
        >
          {genre.name}
        </ToggleButton>;
      }
      );
    }
  };

  const decades = () => {
    if (props.decades) {
      return props.decades.map((decade) => {

        let isSelected = false;
        let filterDecade = props.filterDecades[decade.title];
        if (filterDecade) {
          isSelected = filterDecade;
        }
        return <ToggleButton
          className="muvika-search-filter-toggle-button"
          key={decade.decade}
          value="check"
          selected={isSelected}
          size="small"
          onMouseDown={() => props.onDecadeChange(decade.title, isSelected)}
        >
          {decade.title}
        </ToggleButton>;
      });
    }
  };

  const alphabets = () => {
    if (props.alphabets && !props.isOrderByPopularitySet) {
      return props.alphabets.map((alphabet) => {

        let isSelected = false;
        let filterAlphabet = props.filterAlphabets[alphabet];
        if (filterAlphabet) {
          isSelected = filterAlphabet;
        }
        return <ToggleButton
          className="muvika-search-filter-toggle-button muvika-search-filter-toggle-button-alphabet"
          key={alphabet}
          value="check"
          selected={isSelected}
          size="small"
          onMouseDown={() => props.onAlphabetChange(alphabet, isSelected)}
        >
          {alphabet}
        </ToggleButton>;
      });
    }
  };

  const ordersBy = () => {
    if (props.orderBySongTitle && props.orderByArtistName && props.orderByPopularity) {
      return <div>
        <h5 className="muvika-search-filter-category-title">{TR.cm_browse_results_by}</h5>
        <ToggleButton className="muvika-search-filter-toggle-button" value="check" size="small" selected={props.isOrderBySongTitleSet} onMouseDown={props.orderBySongTitle}>
          {TR.cm_by_song}
        </ToggleButton>
        <ToggleButton className="muvika-search-filter-toggle-button" value="check" size="small" selected={props.isOrderByArtistNameSet} onMouseDown={props.orderByArtistName}>
          {TR.cm_by_artist}
        </ToggleButton>
        <ToggleButton className="muvika-search-filter-toggle-button" value="check" size="small" selected={props.isOrderByPopularitySet} onMouseDown={props.orderByPopularity}>
          {TR.cm_by_popularity}
        </ToggleButton>
      </div>;
    }
  };

  const renderTitle = () => {
    if (props.currentFilter) {
      return <span>{TR.cm_filters}</span>;
    } else {
      return TR.cm_filters;
    }
  };

  return (
    <Accordion
      id={props.id}
      expanded={props.expanded}
      className="muvika-search-filter-accordion"
      onChange={props.onChange}
      TransitionProps={{
        timeout: 0
      }}>
      <AccordionSummary
        className="muvika-search-filter-accordion-summary"
        expandIcon={<ExpandMoreIcon />}>
        {renderTitle()}
      </AccordionSummary>
      <AccordionDetails className="muvika-search-filter-accordion-details">

        <h5 className="muvika-search-filter-category-title">{TR.cm_languages}</h5>
        <ToggleButton className="muvika-search-filter-toggle-button" size="small" value="check" selected={props.isAllLanguageFiltersSet} onMouseDown={props.onAllLanguagesChange}>
          {TR.cm_all_languages}
        </ToggleButton>
        {languages()}

        <h5 className="muvika-search-filter-category-title">{TR.cm_genres}</h5>
        <ToggleButton className="muvika-search-filter-toggle-button" size="small" value="check" selected={props.isAllGenreFiltersSet} onMouseDown={props.onAllGenresChange}>
          {TR.cm_all_genres}
        </ToggleButton>
        {genres()}

        <h5 className="muvika-search-filter-category-title">{TR.cm_decades}</h5>
        <ToggleButton className="muvika-search-filter-toggle-button" size="small" value="check" selected={props.isAllDecadeFiltersSet} onMouseDown={props.onAllDecadesChange}>
          {TR.cm_all_decades}
        </ToggleButton>
        {decades()}

        {ordersBy()}

        <p className="muvika-search-filter-category-title">
          {alphabets()}
        </p>

      </AccordionDetails>
    </Accordion>
  );
}

export default SearchFilters;